module.exports = __webpack_public_path__ + "img/card.ab9b011a.png";